import { render, staticRenderFns } from "./FutureEventsBlock.vue?vue&type=template&id=baf5cfc6&scoped=true&"
import script from "./FutureEventsBlock.vue?vue&type=script&lang=ts&"
export * from "./FutureEventsBlock.vue?vue&type=script&lang=ts&"
import style0 from "./FutureEventsBlock.vue?vue&type=style&index=0&id=baf5cfc6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "baf5cfc6",
  null
  
)

export default component.exports